import {
  GroupButton,
  HeaderTable,
  SelectPageStyled,
  TitleScreen,
} from 'page/Application/VisitedPage/component/HeaderListDataLayout/styled';
import React from 'react';

const HeaderListDataLayout = ({
  titleScreen,
  children,
  value,
  handleChangePageSize,
  pageSizeOptions,
}) => {
  return (
    <HeaderTable>
      <TitleScreen>{titleScreen}</TitleScreen>
      <GroupButton>
        {children}
        <SelectPageStyled
          value={value}
          onChange={handleChangePageSize}
          options={pageSizeOptions}
          title={''}
        />
      </GroupButton>
    </HeaderTable>
  );
};
export default HeaderListDataLayout;
